import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import legalApi from '../../../api/legal';
import { ILegal } from '@wot/typings';
import { Button, Markdown } from '@wot/components';

export function PrivacyPolicies() {
  const [policies, setPolicies] = useState<ILegal[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    legalApi
      .getDocuments('privacy-policy')
      .then((data) => {
        if (data) {
          setPolicies(data);
        }
      })
      .catch((err) => err);
  }, []);

  if (policies.length === 0) {
    return (
      <div className="w-max">
        <Link to={'privacy-policy'} state={{ mode: 'edit' }}>
          <Button text={'Add New Privacy Policy'} onClick={() => { }} />
        </Link>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-5">
      {policies.map((policy) => (
        <div
          key={policy._id}
          onClick={() => {
            navigate('privacy-policy', {
              state: {
                doc: policy,
                mode: policy.status === 'active' ? 'edit' : 'view'
              }
            });
          }}
          className={`w-full flex flex-col gap-5 cursor-pointer ${policy.status === 'active' ? 'bg-neutralBlue2' : 'bg-white border'
            } p-5 rounded-md`}
        >
          <div className="w-full flex items-center justify-between">
            <h1 className="text-base font-semibold">{dayjs(policy.createdAt).format('DD/MM/YYYY')}</h1>
            {policy.status === 'active' && (
              <div className="flex gap-4 items-center justify-center">
                <Button
                  text={'Update'}
                />
              </div>
            )}
          </div>
          <div className="w-full">
            <Markdown markdown={policy.mdText} />
          </div>
        </div>
      ))}
    </div>
  );
}
